import valuationService from '../../../../core/services/Market/MarketInDepth/ValuationService';
import Const from './Const';
import reducerRegistry from '../../../helpers/ReducerRegistry';
import { formatData } from './../../../helpers/Api';
import registerCancelTokenAxios from './../../../helpers/RegisterCancelTokenAxios';
import currentState from './../../../helpers/CurrentState';
import ConstCommon from './../../../common/Const';

const REDUCER_NAME = 'MARKET_IN_DEPTH:VALUATION:';
const FETCH_LIST_CHART = `${REDUCER_NAME}FETCH_LIST_CHART`;
const CHANGE_TIME_RANGE = `${REDUCER_NAME}CHANGE_TIME_RANGE`;
const CHANGE_RATE = `${REDUCER_NAME}CHANGE_RATE`;
const CHANGE_COM_GROUP_CODE = `${REDUCER_NAME}CHANGE_COM_GROUP_CODE`;
const CHANGE_SIZE_COMPONENT = `${REDUCER_NAME}CHANGE_SIZE_COMPONENT`;
const SET_FETCHING = `${REDUCER_NAME}SET_FETCHING`;
const CHANGE_DATE = `${REDUCER_NAME}CHANGE_DATE`;
const INIT_COMPONENT = `${REDUCER_NAME}INIT_COMPONENT`;
const UNMOUNT_COMPONENT = `${REDUCER_NAME}UNMOUNT_COMPONENT`;

export {
  REDUCER_NAME,
  fetchListChart,
  changeTimeRange,
  changeComGroupCode,
  changeRate,
  changeDate,
};

function fetchListChart(startDate, endDate) {
  return (dispatch, getState) => {
    dispatch(setFetching(true));

    registerCancelTokenAxios.delete(REDUCER_NAME);
    const source = registerCancelTokenAxios.register(REDUCER_NAME);

    valuationService
      .getValuationSeries(
        {
          Code: getState()[REDUCER_NAME].comGroupCode,
          TimeRange: getState()[REDUCER_NAME].timeRange,
          FromDate: startDate ? startDate.format('YYYY-MM-DD') : null,
          ToDate: endDate ? endDate.format('YYYY-MM-DD') : null,
        },
        source,
      )
      .then(response => {
        const items = formatData(response);
        dispatch({
          type: FETCH_LIST_CHART,
          payload: {
            listDataChart: items,
          },
        });
        dispatch(setFetching(false));
      });
  };
}

function changeTimeRange(timeRange) {
  return dispatch => {
    dispatch({
      type: CHANGE_TIME_RANGE,
      payload: {
        timeRange,
      },
    });
    currentState.add(
      ConstCommon.listComponent.MarketInDepth,
      'valuation.timeRange',
      timeRange,
    );
    dispatch(fetchListChart());
  };
}

function changeComGroupCode(comGroupCode) {
  return dispatch => {
    dispatch({
      type: CHANGE_COM_GROUP_CODE,
      payload: {
        comGroupCode,
      },
    });
    currentState.add(
      ConstCommon.listComponent.MarketInDepth,
      'valuation.comGroupCode',
      comGroupCode,
    );
    dispatch(fetchListChart());
  };
}

function changeRate(rate) {
  currentState.add(
    ConstCommon.listComponent.MarketInDepth,
    'valuation.rate',
    rate,
  );
  return {
    type: CHANGE_RATE,
    payload: {
      rate,
    },
  };
}

function setFetching(isFetching = false) {
  return {
    type: SET_FETCHING,
    payload: {
      isFetching,
    },
  };
}

function changeDate(startDate, endDate) {
  return dispatch => {
    dispatch({
      type: CHANGE_DATE,
      payload: {
        startDate,
        endDate,
      },
    });
    dispatch(fetchListChart(startDate, endDate));
  };
}

const initialState = {
  listDataChart: [],
  startDate: '',
  endDate: '',
  isFetching: false,
};

function reducer(state = {}, action) {
  switch (action.type) {
    case INIT_COMPONENT:
      return {
        ...state,
        ...initialState,
        comGroupCode:
          currentState.get(
            ConstCommon.listComponent.MarketInDepth,
            'valuation.comGroupCode',
          ) || Const.defaultComGroupCode,
        rate:
          currentState.get(
            ConstCommon.listComponent.MarketInDepth,
            'valuation.rate',
          ) || Const.defaultRate,
        timeRange:
          currentState.get(
            ConstCommon.listComponent.MarketInDepth,
            'valuation.timeRange',
          ) || Const.defaultTimeRange,
      };

    case UNMOUNT_COMPONENT:
      return {};

    case FETCH_LIST_CHART:
    case CHANGE_TIME_RANGE:
    case CHANGE_RATE:
    case CHANGE_COM_GROUP_CODE:
    case SET_FETCHING:
    case CHANGE_DATE:
      return {
        ...state,
        ...action.payload,
      };

    case CHANGE_SIZE_COMPONENT:
      return {
        ...state,
        component: action.payload,
      };

    default:
      return state;
  }
}

reducerRegistry.register(REDUCER_NAME, reducer);
